import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Text } from 'rebass/styled-components';

const textColor = theme('mode', {
  light: (props) => props.theme.colors.darkGrey,
  dark: (props) => props.theme.colors.white,
});

const Label = styled(Text)`
  color: ${textColor};
  text-transform: capitalize;
`;

function EditorLabel(props) {
  const {
    largeSized, ...otherProps
  } = props;

  return (
    <Label
      mb={3}
      fontSize={largeSized ? 2 : 1}
      fontWeight={largeSized ? 500 : 300}
      data-testid="editor-label"
      letterSpacing={largeSized ? '0.02em' : 'normal'}
      lineHeight={largeSized ? '133%' : 'normal'}
      {...otherProps}
    />
  );
}

EditorLabel.defaultProps = {
  largeSized: false,
};

EditorLabel.propTypes = {
  largeSized: PropTypes.bool,
};

export default EditorLabel;
